

const websoket = {
      state: {
        ws: undefined,
        heartTimeOut: 40000, //监测心跳时间 40秒
        //this.isReConnection = false
        lockReconnect: false, //避免重连
        timerReconnect: undefined ,
        timerHeart: undefined ,
        timerServerHeart: undefined,
        handClose: false,
        msg: "",
        wsUrl:"",
        // ip:undefined,
        timeStamp:""
       },
        connection(url,ip){
          console.log(url,ip)
          if("WebSocket" in window){
            this.wsUrl = url;
            // this.ip = ip;
            this.createWebSocket()
            // getlocalIP(function(ip:string){
            //      alert("Got IP! :" + ip);
            //   });
          }
          else{
            console.log("您的浏览器不支持websocket通信")
          }    
        },
  
        //初始化
        createWebSocket(){
          try{
            // let token =store.state.app.token || "476d63f5fea8414da37050e799505a40";
            // token = encodeURIComponent(token)
            let url = "ws://127.0.0.1:8080";
            // if(this.state.timeStamp){
            //   url = this.state.wsUrl+`&token=${token}&timestamp=${this.state.timeStamp}`
            // }else{
            //   url = this.state.wsUrl+`&token=${token}`
            // }
            
            this.ws = new WebSocket(url) 
            // console.log( "this.ws")
            // console.log( this.ws)
             
            this.initWebsocket()
             
          }
          catch(e){
            console.log("catch eeeee=", e)
            this.reConnection()
          }
        },
       
        initWebsocket(){
       
          //建立连接
          this.ws.onopen = (e)=>{
            let data = {"type":1,"message":`{\"route\":\"init\"}`}
            // let data = {"type":1,"message":`{\"ip\":\"${this.ip}\"}`}
            //webSocket业务订阅——可以有多个业务
            this.ws.send(JSON.stringify(data));
            console.log("连接成功",e)
            if(this.state.timeStamp){
              this.state.timeStamp = ""
            }
            //连接成功后，需要开启监测心跳
            this.heartCheck()
          }
       
          this.ws.onmessage = (messages)=>{
            console.log("messages+++++++++++++")
            console.log(messages)
            //  window.location.href = "https://www.baidu.com/"
            //  window.location.href = messages.route
            // console.log(messages.data)
            // let msg = messages.data
            // if(msg.includes("{")){
            //   msg = JSON.parse(msg)
            // }
            // this.state.msg = msg
            // console.log("store")
            // console.log(store)
            // store.dispatch("app/uploadWsMsg",msg).then(res=>{
            //     console.log(res)
                
            // })
        
            //接收到消息后，需要开启监测心跳
            this.heartCheck()
          }
       
         
          this.ws.onerror = (e)=>{       //连不上时onerror 和 onclose 监听同时会捕捉到
            console.log("连接失败",e)
            this.state.timeStamp = new Date().getTime();
            // 连失败需要重连
            this.reConnection()
          }
       
          this.ws.onclose = (e)=>{
            console.log("关闭连接",e)
            
            //是否正常关闭  正常关闭不需要重连， 否则需要重连
            if(!this.handClose){
              this.reConnection()
            }
          }
        },
       
        clearTimer(){
            this.state.timerReconnect && clearTimeout( this.state.timerReconnect)
            this.state.timerHeart && clearTimeout( this.state.timerHeart)
            this.state.timerServerHeart && clearTimeout( this.state.timerServerHeart)
        },
       
        //重连
        reConnection(){
          console.log("重新连接")
          if( this.state.lockReconnect){
            return
          }
          this.state.lockReconnect = true
          if( this.state.timerReconnect) {
            clearTimeout( this.state.timerReconnect)
          } 
       
          //没连上会一直重连， 设置迟延，避免请求过多
          this.state.timerReconnect = setTimeout(() => { //setTimeout 到点了执行
            this.connection(  this.state.wsUrl,"")
            this.state.lockReconnect = false
          }, 5000);
           
        },
         
       
        //心跳
        heartCheck(){
         
          if( this.state.timerHeart){
            clearInterval( this.state.timerHeart)
          }
       
          // if(this.timerServerHeart){
          //   clearTimeout(this.timerServerHeart)
          // }
       
          this.state.timerHeart = setInterval(() => {
            // console.log("PING");
            let data = {"type":0,"message":`{\"data\":\"check\"}`}
            //webSocket业务订阅——可以有多个业务
            this.ws.send(JSON.stringify(data));
            // this.ws.send("PING");
            console.log("监测心跳")      
            this.state.lockReconnect = false
          },  this.state.heartTimeOut); //40秒
       
        },
       
        //发送消息
        sendMsg(data){
          console.log("发送消息")
          if(this.ws.readyState === WebSocket.OPEN){
            this.ws.send(JSON.stringify(data))
          }
        },
       
        //关闭连接 手动关闭
        closeWs(){
          console.log("手动关闭ws")
          this.handClose = true
          this.clearTimer()
          this.ws.close()
        }
      }
    
   
  export default websoket
